module.exports = __webpack_public_path__ + "media/application/images/2018/popup-close-2-1ba3296bd009fdd05f4ce690ab7a6a16.svg";